export default "__VITE_ASSET__Vj6vri5y__"